import React, {Component} from "react";
import "./InquiryHeader.css";
import {FormattedMessage} from "react-intl";

class InquiryHeader extends Component {
    render() {
        return (
            <div>
                <div className="container-fluid responsive-userAddress-table">
                    <div className="row">
                        <div className="col-md-1 no-padding">
                            <label>
                                <FormattedMessage id="app.inquiry-header.title"
                                                  defaultMessage="#"
                                                  description=""/>
                            </label>
                        </div>
                        <div className="col-md-2 no-padding">
                            <label>
                                <FormattedMessage id="app.inquiry-header.date"
                                                  defaultMessage="Date"
                                                  description=""/>
                            </label>
                        </div>
                        <div className="col-md-3 ">
                            <label>
                                <FormattedMessage id="app.inquiry-header.subject"
                                                  defaultMessage="Subject"
                                                  description=""/>
                            </label>
                        </div>
                        {/*<div className="col-md-4 no-padding">*/}
                            {/*<label>*/}
                                {/*<FormattedMessage id="app.inquiry-header.message"*/}
                                                  {/*defaultMessage="Message"*/}
                                                  {/*description=""/>*/}
                            {/*</label>*/}
                        {/*</div>*/}
                        <div className="col-md-4 no-padding">
                            <label>
                                <FormattedMessage id="app.inquiry-row.reply"
                                                  defaultMessage="Last Reply"
                                                  description=""/>
                            </label>
                        </div>
                        <div className="col-md-2">
                            <label>
                                <FormattedMessage id="app.inquiry-header.actions"
                                                  defaultMessage="Actions"
                                                  description=""/>
                            </label>
                        </div>
                    </div>
                </div>
                <hr id="header-separator"/>
            </div>
        )
    }
}

export default InquiryHeader;



// WEBPACK FOOTER //
// ./src/components/Site/UserInquiry/InquiryHeader/InquiryHeader.js